export default __webpack_public_path__ + "static/media/save-disabled.860a8b6c.svg";